import { useState } from 'react';
import { X, AlertTriangle, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { formatOrderNumberLabel } from '../lib/orderUtils';

export default function CancelOrderModal({ order, onClose, onConfirm }) {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm(order.order_id, reason);
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-card rounded-2xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b">
          <div className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="w-5 h-5" />
            <h2 className="font-bold text-lg">Cancel Order</h2>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-muted rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          <div className="bg-destructive/10 text-destructive p-4 rounded-lg text-sm">
            <p className="font-medium mb-1">This action cannot be undone</p>
            <p>
              Cancelling this order will trigger an automatic refund of 
              <strong> CA$ {order.total_amount.toFixed(2)}</strong> to the student.
            </p>
          </div>

          <div>
            <p className="text-sm text-muted-foreground mb-2">
              Order {formatOrderNumberLabel(order)} • {order.student_name}
            </p>
            <div className="text-sm">
              {order.items.map((item, i) => (
                <p key={i}>{item.quantity}x {item.name}</p>
              ))}
            </div>
          </div>

          <div>
            <label className="text-sm font-medium mb-2 block">
              Reason for cancellation (optional)
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="e.g., Ingredient shortage, closing early..."
              className="w-full p-3 rounded-lg bg-muted border-0 resize-none text-sm"
              rows={3}
              data-testid="cancel-reason"
            />
          </div>

          <div className="flex gap-3 pt-2">
            <Button 
              variant="outline" 
              className="flex-1" 
              onClick={onClose}
              disabled={loading}
            >
              Keep Order
            </Button>
            <Button 
              variant="destructive" 
              className="flex-1"
              onClick={handleConfirm}
              disabled={loading}
              data-testid="confirm-cancel"
            >
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Processing...
                </>
              ) : (
                'Cancel & Refund'
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
